/**
 * Created by AlexanderC on 5/25/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Response = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MissingRuntimeContextException = require('./Exception/MissingRuntimeContextException');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Response sent to the lambda context
 */
let Response = exports.Response = function () {
  /**
   * @param {Runtime} runtime
   * @param {Object} data
   */
  function Response(runtime, data) {
    _classCallCheck(this, Response);

    this._data = data;
    this._runtime = runtime;
  }

  /**
   * @returns {Runtime}
   */


  _createClass(Response, [{
    key: 'send',


    /**
     * @returns {Response}
     */
    value: function send() {
      if (!this._runtime.context) {
        throw new _MissingRuntimeContextException.MissingRuntimeContextException();
        // @todo: Figure out why lambda container caches _runtime.contextSent
        // } else if (this.contextSent) {
        //   throw new ContextAlreadySentException();
      }

      this.runtime.logService.rumLog({
        service: 'deep-core',
        resourceType: 'Lambda',
        resourceId: this.runtime.context.invokedFunctionArn,
        eventName: 'Run'
      });

      // flush RUM batched messages if any
      this.runtime.logService.rumFlush((error, data) => {
        // @todo: via setter?
        this._runtime._contextSent = true;

        (this._runtime.resolver || this._runtime.context)[this.constructor.contextMethod](this.data);
      });

      return this;
    }

    /**
     *
     * @returns {Object}
     * @private
     */

  }, {
    key: 'runtime',
    get: function get() {
      return this._runtime;
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'contextSent',
    get: function get() {
      return this._runtime.contextSent;
    }
  }, {
    key: 'data',
    get: function get() {
      return this._data;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'rawData',
    get: function get() {
      return this._data;
    }

    /**
     * @returns {String}
     */

  }], [{
    key: 'contextMethod',
    get: function get() {
      return 'succeed';
    }
  }]);

  return Response;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/Lambda/Response.js
// module id = 164
// module chunks = 0